import { selectIsExperimentGroupNameB } from './selectIsExperimentGroupNameB';
import { VALUATION_MY_HOME } from '../../../constants/experiments';
import { IApplicationState } from '../../../types/redux';
import { isExperimentActive } from '../../../utils/experiments';
import { selectExperiments } from '../experiments';

export const selectIsMyHomeRedesign = (state: IApplicationState) => {
  const experiments = selectExperiments(state);

  const isGroupNameB = selectIsExperimentGroupNameB(state);
  const isGroupNameC = isExperimentActive(experiments, VALUATION_MY_HOME, 'C');

  return isGroupNameB || isGroupNameC;
};
